<template>
  <div class="dft-container" :style="container_Style">
    <div class="dft-search_box" :style="search_box_Style">
      <div class="dft-search_keys" :style="search_keys_style">
        <div class="dft-search_icon">
          <!-- uniapp -->
          <i class="el-icon-s-shop"></i>
        </div>
        <div class="dft-search_key">
          {{estext}}
        </div>
      </div>
      <div v-if="scan" class="dft-search_scan">
        {{estext}}
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    compData: {
      type: [Array, Object],
      default: () => []
    }
  },
  options: {
    styleIsolation: 'shared' // 解除样式隔离
  },
  data () {
    return {
      showDialog: false
    }
  },
  watch: {
    compData: {
      handler: function (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            // console.log('comp--D-ata',newVal)
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 数据
    estext () {
      return this.compData?.attr?.a1.value
    },
    scan () {
      return this.compData?.attr?.a6.value == '1'
    },
    // 样式
    container_Style () {
      return {
        'height': `${this.compData?.attr?.a5.value}px`,
        'background': this.compData?.attr?.a7.value
      }
    },
    search_box_Style () {
      return {
        [this.compData?.attr?.['a8']?.key]: this.compData?.attr?.['a8']?.value,
        [this.compData?.attr?.['a9']?.key]: this.compData?.attr?.['a9']?.value
      }
    },
    search_keys_style () {
      return {
        'padding-right': this.scan ? '60px' : '0'
      }
    },
    search_btn_style () {
      return {
        'border-radius': `${(this.compData?.attr?.a5.value - 6) / 2}px`
        // 'background': this.compData?.attr?.['a9']?.value,
      }
    }
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData () {
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-container{
  width: 100%;
  height: auto;
  box-sizing: border-box;
}
.dft-search_box{
  display: flex;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  align-items: center;
  font-size: 14px;
}
.dft-search_keys{
  flex: 1;
  display: flex;
  .dft-search_icon{
    padding: 0 6px;
  }
}
.dft-search_scan{
  padding: 0 6px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.dft-search_btn{
  background: #fd2e08;
  color: #fff;
  width: 60px;
  height: calc(100% - 6px);
  margin: 0 3px;
  padding: 4px 6px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
